import * as React from "react";
import { useDispatch } from "@teamprevent/employee-redux";
import { Container, Loader, Header, Segment } from "semantic-ui-react";

import { PpqManagerSection } from "@teamprevent/common/ppq/components/PpqManagerSection";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import { Covid19FeatureType } from "@teamprevent/common/model";
import { QuestionnaireConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { loadOrgStructure as loadOrgStructureAction } from "@teamprevent/common/questionnaires/components/referralForm/actions";
import { WorkGroup } from "@teamprevent/common/workGroup/model";

import { workGroupApi } from "../../workGroup/workGroupApi";
import { useCustomMedicalTypes } from "../../customMedicalTypes/hooks";

interface Props {
    readonly: boolean;
    questionnaireConfig: QuestionnaireConfig;
    submitQuestionnaire?: (answers: AnsweredQuestionWithId[], questionnaireKey: string) => Promise<boolean>;
    loadOrgStructure: (parentOrgStructureLevelId: string) => void;
    allowedCovid19Features: string[];
    customerWorkGroups: WorkGroup[];
}

export const PpqForm: React.FunctionComponent<Props> = (props: Props) => {

    const [loading, setLoading] = React.useState<boolean>(true);
    const [customerWorkGroups, setCustomerWorkGroups] = React.useState<WorkGroup[]>([]);
    const { customMedicalTypes, isLoaded } = useCustomMedicalTypes({ enable: true });

    const dispatch = useDispatch();

    React.useEffect(() => {
        (async () => {
            const workGroups = await workGroupApi.getAll();
            setCustomerWorkGroups(workGroups);
        })();

        setLoading(false);
    }, []);

    const loadOrgStructure = (parentOrgStructureLevelId: string) => {
        dispatch(loadOrgStructureAction(parentOrgStructureLevelId));
    };

    if (props.questionnaireConfig && !loading && isLoaded) {
        return (
            <Container className="ppq-form">
                <Container>
                    <Segment basic>
                        <Header as="h1">Pre-placement Questionnaire</Header>
                    </Segment>
                </Container>
                <PpqManagerSection
                    questionnaireConfig={props.questionnaireConfig}
                    readonly={props.readonly}
                    submitQuestionnaire={props.submitQuestionnaire}
                    loadOrgStructure={loadOrgStructure}
                    showCovid19Questions={props.allowedCovid19Features?.indexOf(Covid19FeatureType.PPQ_RISK_ASSESSMENT) > -1}
                    customerWorkGroups={customerWorkGroups}
                    customMedicalTypes={customMedicalTypes}
                />
            </Container>
        );
    }

    return <Loader active />;
};
